module.exports = __webpack_public_path__ + "static/media/search.d0757cde.svg";